import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../../../contexts/AuthContext";
import { toast } from "react-toastify";

const GetPositionsTimelineForm = ({ availableLogins = [] }) => {
  const [formData, setFormData] = useState({
    login: "",
    from_time: "",
    to_time: "",
    target: "individuals",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [responseData, setResponseData] = useState(null);
  const [expandedPositions, setExpandedPositions] = useState({});
  const [filters, setFilters] = useState({
    actionType: "all", // all, buy, sell
    profitType: "all", // all, profit, loss
  });
  const { apiBaseUrl } = useAuth();

  const handleSubmit = async (e) => {


    e.preventDefault();
    setLoading(true);
    setMessage("");
    setResponseData(null);
    setExpandedPositions({});

    try {
      const response = await axios.post(
        `${apiBaseUrl}/api/admin/final/accounts/positions/login/timeline`,
        {
          login: formData.login,
          from_time: formData.from_time + ":00",
          to_time: formData.to_time + ":00",
          target: formData.target,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      console.log(response)
      if(response.data.ok == false){
        toast.error(response.data.error)
      }else{
           toast.success("اطلاعات تایم‌لاین با موفقیت دریافت شد")
      }

      setResponseData(response.data);
      setMessage("اطلاعات تایم‌لاین با موفقیت دریافت شد");
   
    } catch (error) {
      console.error("Error:", error);
      setMessage(error.response?.data?.message || "خطا در دریافت اطلاعات");
      toast.error(error.message)
    } finally {
      setLoading(false);
    }
  };

  const formatDateTime = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const setLast24Hours = () => {
    const now = new Date();
    const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);

    setFormData({
      ...formData,
      from_time: formatDateTime(yesterday),
      to_time: formatDateTime(now),
    });
  };

  const shiftTime = (hours) => {
    if (!formData.from_time || !formData.to_time) {
      setMessage("لطفاً ابتدا تاریخ و زمان را انتخاب کنید");
      setTimeout(() => setMessage(""), 3000);
      return;
    }

    const fromDate = new Date(formData.from_time);
    const toDate = new Date(formData.to_time);

    fromDate.setHours(fromDate.getHours() + hours);
    toDate.setHours(toDate.getHours() + hours);

    setFormData({
      ...formData,
      from_time: formatDateTime(fromDate),
      to_time: formatDateTime(toDate),
    });
  };

  const togglePosition = (ticket) => {
    setExpandedPositions((prev) => ({
      ...prev,
      [ticket]: !prev[ticket],
    }));
  };

  const getFilteredPositions = () => {
    if (!responseData?.data?.data?.all_position_data) return [];

    let filtered = responseData.data.data.all_position_data;

    // Filter by action type
    if (filters.actionType !== "all") {
      filtered = filtered.filter((pos) => {
        if (filters.actionType === "buy") return pos.action_string === "BUY";
        if (filters.actionType === "sell") return pos.action_string === "SELL";
        return true;
      });
    }

    // Filter by profit/loss
    if (filters.profitType !== "all") {
      filtered = filtered.filter((pos) => {
        const profit = parseFloat(pos.profit);
        if (filters.profitType === "profit") return profit >= 0;
        if (filters.profitType === "loss") return profit < 0;
        return true;
      });
    }

    return filtered;
  };

  const filteredPositions = getFilteredPositions();

  return (
    <div className="space-y-6 p-6">
      <h3 className="text-xl font-semibold text-white mb-6">
        دریافت Timeline موقعیت‌ها
      </h3>

      {message && (
        <div
          className={`p-4 rounded-lg text-center ${
            message.includes("موفقیت")
              ? "bg-green-900 border border-green-600 text-green-400"
              : "bg-red-900 border border-red-600 text-red-400"
          }`}
        >
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Target Selection */}
        <div className="bg-gray-800 border border-gray-600 rounded-lg p-4">
          <label className="block text-white font-medium mb-3">
            انتخاب نوع حساب:
          </label>
          <div className="flex gap-4">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="target"
                value="individuals"
                checked={formData.target === "individuals"}
                onChange={(e) =>
                  setFormData({ ...formData, target: e.target.value })
                }
                className="w-5 h-5 accent-blue-600"
              />
              <span className="text-white">Individuals (حساب‌های فردی)</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="target"
                value="groups"
                checked={formData.target === "groups"}
                onChange={(e) =>
                  setFormData({ ...formData, target: e.target.value })
                }
                className="w-5 h-5 accent-blue-600"
              />
              <span className="text-white">Groups (گروه‌ها)</span>
            </label>
          </div>
        </div>

        {/* Login */}
        <div>
          <label className="block text-white font-medium mb-2">Login ID:</label>

          {availableLogins.length > 0 ? (
            <>
              <select
                value={formData.login}
                onChange={(e) =>
                  setFormData({ ...formData, login: e.target.value })
                }
                className="w-full p-3 bg-gray-800 border border-gray-600 rounded-lg text-white focus:border-green-500 focus:outline-none mb-2"
              >
                <option value="">انتخاب از لیست یا وارد کردن دستی...</option>
                {availableLogins.map((loginObj) => (
                  <option key={loginObj.login} value={loginObj.login}>
                    {loginObj.login}
                    {loginObj.name && ` - ${loginObj.name}`}
                    {` (${loginObj.isActive ? "فعال" : "غیرفعال"})`}
                  </option>
                ))}
              </select>
              <p className="text-gray-400 text-xs mb-2">یا وارد کنید:</p>
            </>
          ) : null}

          <input
            type="text"
            value={formData.login}
            onChange={(e) =>
              setFormData({ ...formData, login: e.target.value })
            }
            placeholder="شماره Login را وارد کنید"
            className="w-full p-3 bg-gray-800 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:border-green-500 focus:outline-none"
            required
          />
        </div>

        {/* Time Selection with Shift Buttons */}
        <div className="bg-gray-800 border border-gray-600 rounded-lg p-4">
          <div className="flex items-center justify-between mb-3">
            <label className="text-white font-medium">بازه زمانی:</label>
            <div className="flex gap-2">
              <button
                type="button"
                onClick={() => shiftTime(-1)}
                className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white text-sm rounded-lg transition duration-200 flex items-center gap-1"
                title="1 ساعت قبل"
              >
                ◄ قبل
              </button>
              <button
                type="button"
                onClick={() => shiftTime(1)}
                className="px-4 py-2 bg-orange-600 hover:bg-orange-700 text-white text-sm rounded-lg transition duration-200 flex items-center gap-1"
                title="1 ساعت بعد"
              >
                بعد ►
              </button>
            </div>
          </div>

          {/* From Time */}
          <div className="mb-3">
            <label className="block text-gray-300 text-sm mb-2">
              از تاریخ و زمان:
            </label>
            <input
              type="datetime-local"
              value={formData.from_time}
              onChange={(e) =>
                setFormData({ ...formData, from_time: e.target.value })
              }
              className="w-full p-3 bg-gray-900 border border-gray-600 rounded-lg text-white focus:border-green-500 focus:outline-none"
              required
            />
          </div>

          {/* To Time */}
          <div>
            <label className="block text-gray-300 text-sm mb-2">
              تا تاریخ و زمان:
            </label>
            <input
              type="datetime-local"
              value={formData.to_time}
              onChange={(e) =>
                setFormData({ ...formData, to_time: e.target.value })
              }
              className="w-full p-3 bg-gray-900 border border-gray-600 rounded-lg text-white focus:border-green-500 focus:outline-none"
              required
            />
          </div>

          <p className="text-gray-400 text-xs mt-3">
            💡 با دکمه‌های "قبل" و "بعد" می‌توانید بازه زمانی را 1 ساعت جابجا
            کنید
          </p>
        </div>

        {/* Quick Actions */}
        <div className="flex gap-2">
          <button
            type="button"
            onClick={setLast24Hours}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded-lg transition duration-200"
          >
            24 ساعت گذشته
          </button>
        </div>

        <button
          type="submit"
          disabled={
            loading ||
            !formData.login ||
            !formData.from_time ||
            !formData.to_time
          }
          className="w-full py-3 px-6 bg-green-600 hover:bg-green-700 disabled:bg-gray-600 text-white font-medium rounded-lg transition duration-200 flex items-center justify-center gap-2"
        >
          {loading ? (
            <>
              <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
              در حال دریافت...
            </>
          ) : (
            "دریافت Timeline"
          )}
        </button>
      </form>

      {/* Response Display */}
      {responseData && responseData.data?.data && (
        <div className="space-y-6">
          {/* Statistics Summary */}
          {responseData.data.data.statistics && (
            <div className="bg-gradient-to-r from-blue-900 to-purple-900 border border-blue-600 rounded-lg p-6">
              <h4 className="text-white font-bold text-lg mb-4 flex items-center gap-2">
                <span>📊</span> خلاصه آمار
              </h4>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="bg-black/30 rounded-lg p-3">
                  <p className="text-gray-300 text-xs mb-1">تعداد کل:</p>
                  <p className="text-white font-bold text-xl">
                    {responseData.data.data.statistics.total_data_items}
                  </p>
                </div>
                <div className="bg-black/30 rounded-lg p-3">
                  <p className="text-gray-300 text-xs mb-1">سود/ضرر کل:</p>
                  <p
                    className={`font-bold text-xl ${
                      parseFloat(
                        responseData.data.data.statistics.total_profit
                      ) >= 0
                        ? "text-green-400"
                        : "text-red-400"
                    }`}
                  >
                    {parseFloat(
                      responseData.data.data.statistics.total_profit
                    ).toFixed(2)}
                  </p>
                </div>
                <div className="bg-black/30 rounded-lg p-3">
                  <p className="text-gray-300 text-xs mb-1">Long:</p>
                  <p className="text-green-400 font-bold text-xl">
                    {responseData.data.data.statistics.long_positions}
                  </p>
                </div>
                <div className="bg-black/30 rounded-lg p-3">
                  <p className="text-gray-300 text-xs mb-1">Short:</p>
                  <p className="text-red-400 font-bold text-xl">
                    {responseData.data.data.statistics.short_positions}
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Filters */}
          {responseData.data.data.all_position_data &&
            responseData.data.data.all_position_data.length > 0 && (
              <div className="bg-gray-800 border border-gray-600 rounded-lg p-4">
                <h4 className="text-white font-medium mb-3 flex items-center gap-2">
                  <span>🔍</span> فیلترها
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* Action Type Filter */}
                  <div>
                    <label className="block text-gray-300 text-sm mb-2">
                      نوع معامله:
                    </label>
                    <div className="flex gap-2">
                      <button
                        type="button"
                        onClick={() =>
                          setFilters({ ...filters, actionType: "all" })
                        }
                        className={`flex-1 py-2 px-4 rounded-lg transition duration-200 ${
                          filters.actionType === "all"
                            ? "bg-blue-600 text-white"
                            : "bg-gray-700 text-gray-300 hover:bg-gray-600"
                        }`}
                      >
                        همه
                      </button>
                      <button
                        type="button"
                        onClick={() =>
                          setFilters({ ...filters, actionType: "buy" })
                        }
                        className={`flex-1 py-2 px-4 rounded-lg transition duration-200 ${
                          filters.actionType === "buy"
                            ? "bg-green-600 text-white"
                            : "bg-gray-700 text-gray-300 hover:bg-gray-600"
                        }`}
                      >
                        BUY 📈
                      </button>
                      <button
                        type="button"
                        onClick={() =>
                          setFilters({ ...filters, actionType: "sell" })
                        }
                        className={`flex-1 py-2 px-4 rounded-lg transition duration-200 ${
                          filters.actionType === "sell"
                            ? "bg-red-600 text-white"
                            : "bg-gray-700 text-gray-300 hover:bg-gray-600"
                        }`}
                      >
                        SELL 📉
                      </button>
                    </div>
                  </div>

                  {/* Profit Type Filter */}
                  <div>
                    <label className="block text-gray-300 text-sm mb-2">
                      نوع نتیجه:
                    </label>
                    <div className="flex gap-2">
                      <button
                        type="button"
                        onClick={() =>
                          setFilters({ ...filters, profitType: "all" })
                        }
                        className={`flex-1 py-2 px-4 rounded-lg transition duration-200 ${
                          filters.profitType === "all"
                            ? "bg-blue-600 text-white"
                            : "bg-gray-700 text-gray-300 hover:bg-gray-600"
                        }`}
                      >
                        همه
                      </button>
                      <button
                        type="button"
                        onClick={() =>
                          setFilters({ ...filters, profitType: "profit" })
                        }
                        className={`flex-1 py-2 px-4 rounded-lg transition duration-200 ${
                          filters.profitType === "profit"
                            ? "bg-green-600 text-white"
                            : "bg-gray-700 text-gray-300 hover:bg-gray-600"
                        }`}
                      >
                        سود 💰
                      </button>
                      <button
                        type="button"
                        onClick={() =>
                          setFilters({ ...filters, profitType: "loss" })
                        }
                        className={`flex-1 py-2 px-4 rounded-lg transition duration-200 ${
                          filters.profitType === "loss"
                            ? "bg-red-600 text-white"
                            : "bg-gray-700 text-gray-300 hover:bg-gray-600"
                        }`}
                      >
                        ضرر 📉
                      </button>
                    </div>
                  </div>
                </div>

                {/* Filter Results Count */}
                <div className="mt-3 pt-3 border-t border-gray-700">
                  <p className="text-gray-300 text-sm">
                    نمایش {filteredPositions.length} از{" "}
                    {responseData.data.data.all_position_data.length} موقعیت
                  </p>
                </div>
              </div>
            )}

          {/* Positions List */}
          {filteredPositions.length > 0 ? (
            <div className="space-y-3">
              <h4 className="text-white font-bold text-lg flex items-center gap-2">
                <span>📈</span> لیست موقعیت‌ها ({filteredPositions.length} مورد)
              </h4>

              {filteredPositions.map((position, index) => {
                const isExpanded = expandedPositions[position.ticket];
                const profit = parseFloat(position.profit);

                return (
                  <div
                    key={index}
                    className={`rounded-lg border-l-4 transition-all duration-200 ${
                      profit >= 0
                        ? "bg-green-900/20 border-green-500"
                        : "bg-red-900/20 border-red-500"
                    }`}
                  >
                    {/* Collapsed View - Always Visible */}
                    <div
                      onClick={() => togglePosition(position.ticket)}
                      className="p-4 cursor-pointer hover:bg-gray-800/50 transition-colors"
                    >
                      <div className="flex justify-between items-center">
                        <div className="flex items-center gap-3">
                          <span className="text-2xl">
                            {position.action_string === "BUY" ? "📈" : "📉"}
                          </span>
                          <div>
                            <div className="flex items-center gap-2 mb-1">
                              <h5 className="text-white font-bold text-lg">
                                {position.symbol}
                              </h5>
                              <span
                                className={`px-2 py-0.5 rounded-full text-xs font-bold ${
                                  position.action_string === "BUY"
                                    ? "bg-green-600 text-white"
                                    : "bg-red-600 text-white"
                                }`}
                              >
                                {position.action_string}
                              </span>
                              {position.is_closed === "true" && (
                                <span className="px-2 py-0.5 rounded-full text-xs font-bold bg-gray-600 text-white">
                                  CLOSED
                                </span>
                              )}
                            </div>
                            <p className="text-gray-400 text-xs">
                              Ticket: {position.ticket} | Volume:{" "}
                              {parseFloat(position.volume_lots).toFixed(2)} lots
                            </p>
                          </div>
                        </div>

                        <div className="flex items-center gap-4">
                          <div className="text-right">
                            <p
                              className={`text-xl font-bold ${
                                profit >= 0 ? "text-green-400" : "text-red-400"
                              }`}
                            >
                              {profit.toFixed(2)}
                            </p>
                            <p className="text-gray-400 text-xs">P/L</p>
                          </div>
                          <div className="text-gray-400">
                            {isExpanded ? "▲" : "▼"}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Expanded View - Details */}
                    {isExpanded && (
                      <div className="px-4 pb-4 space-y-3 border-t border-gray-700 pt-3">
                        {/* Details Grid */}
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                          <div className="bg-gray-800/50 rounded p-2">
                            <p className="text-gray-400 text-xs mb-1">
                              Open Price:
                            </p>
                            <p className="text-white font-medium">
                              {parseFloat(position.price_open).toFixed(5)}
                            </p>
                          </div>
                          <div className="bg-gray-800/50 rounded p-2">
                            <p className="text-gray-400 text-xs mb-1">
                              Current Price:
                            </p>
                            <p className="text-white font-medium">
                              {parseFloat(position.price_current).toFixed(5)}
                            </p>
                          </div>
                          <div className="bg-gray-800/50 rounded p-2">
                            <p className="text-gray-400 text-xs mb-1">
                              Duration:
                            </p>
                            <p className="text-white font-medium">
                              {position.position_duration_minutes
                                ? `${parseFloat(
                                    position.position_duration_minutes
                                  ).toFixed(1)}m`
                                : "—"}
                            </p>
                          </div>
                          <div className="bg-gray-800/50 rounded p-2">
                            <p className="text-gray-400 text-xs mb-1">
                              Position Value:
                            </p>
                            <p className="text-white font-medium">
                              {parseFloat(position.position_value).toFixed(2)}
                            </p>
                          </div>
                        </div>

                        {/* Stop Loss & Take Profit */}
                        <div className="grid grid-cols-2 gap-3">
                          <div className="bg-gray-800/50 rounded p-2">
                            <p className="text-gray-400 text-xs mb-1">
                              Stop Loss:
                            </p>
                            <p className="text-white font-medium">
                              {position.sl !== "0.00000000"
                                ? parseFloat(position.sl).toFixed(5)
                                : "—"}
                            </p>
                          </div>
                          <div className="bg-gray-800/50 rounded p-2">
                            <p className="text-gray-400 text-xs mb-1">
                              Take Profit:
                            </p>
                            <p className="text-white font-medium">
                              {position.tp !== "0.00000000"
                                ? parseFloat(position.tp).toFixed(5)
                                : "—"}
                            </p>
                          </div>
                        </div>

                        {/* Times */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                          <div className="bg-gray-800/50 rounded p-2">
                            <p className="text-gray-400 text-xs mb-1">
                              Create Time:
                            </p>
                            <p className="text-white text-sm">
                              {position.time_create}
                            </p>
                          </div>
                          {position.time_close && (
                            <div className="bg-gray-800/50 rounded p-2">
                              <p className="text-gray-400 text-xs mb-1">
                                Close Time:
                              </p>
                              <p className="text-white text-sm">
                                {position.time_close}
                              </p>
                            </div>
                          )}
                          {position.close_reason_string && (
                            <div className="bg-gray-800/50 rounded p-2">
                              <p className="text-gray-400 text-xs mb-1">
                                Close Reason:
                              </p>
                              <p className="text-yellow-400 text-sm font-medium">
                                {position.close_reason_string}
                              </p>
                            </div>
                          )}
                        </div>

                        {/* Comment */}
                        {position.comment && (
                          <div className="bg-gray-800/30 rounded p-3">
                            <p className="text-gray-400 text-xs mb-1">
                              Comment:
                            </p>
                            <p className="text-gray-300 text-sm">
                              {position.comment}
                            </p>
                          </div>
                        )}

                        {/* Enhanced Summary */}
                        {position.enhanced_summary && (
                          <div className="pt-2 border-t border-gray-700">
                            <p className="text-blue-400 text-sm">
                              {position.enhanced_summary}
                            </p>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="bg-gray-800 border border-gray-600 rounded-lg p-8 text-center">
              <p className="text-gray-400 text-lg">
                هیچ موقعیتی با فیلترهای انتخاب شده یافت نشد
              </p>
            </div>
          )}

          {/* Raw JSON (Optional - for debugging) */}
          <details className="bg-gray-800 border border-gray-600 rounded-lg p-4">
            <summary className="text-white font-medium cursor-pointer hover:text-blue-400">
              نمایش JSON کامل (برای debugging)
            </summary>
            <pre className="bg-gray-900 p-4 rounded-lg text-gray-300 text-xs overflow-x-auto max-h-96 overflow-y-auto mt-3">
              {JSON.stringify(responseData, null, 2)}
            </pre>
          </details>
        </div>
      )}
    </div>
  );
};

export default GetPositionsTimelineForm;
